import * as React from "react"
import { Col, Row } from "react-grid-system"
import styled from "styled-components"
import Card from "../atoms/Card"
import CardBar from "../atoms/CardBar"
import Subtitle from "../atoms/typography/Subtitle"
import { theme } from "../theme"
import { HorizontalSpacer } from "../atoms/spacers"
import MemberProfileOverview from "./MemberProfileOverview"
import { SlideOutHeight } from "../atoms/animations/SlideOutHeight"
import HoverLinkText from "../atoms/buttons/HoverLinkText"
import PrimaryButton from "../atoms/buttons/PrimaryButton"
import { CheckmarkIcon } from "../atoms/icons/CheckboxIcons"
import { Member } from "../../utils/models"
import { FALLBACK_PICTURE } from "../../utils/design-helpers"
import { ArrowDropDownIcon } from "../atoms/icons/ArrowDropDownIcon"
import { ArrowDropUpIcon } from "../atoms/icons/ArrowDropUpIcon"

interface Props {
  groupName: string
  members: Array<Member>
  terminals: Array<any>
  onClickInviteToSelectedGroups: () => void
}

const Content = styled.div`
  padding: ${(props) => props.theme.spacings.large};
`

const SelectSection = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const GroupSelectionSection: React.FunctionComponent<Props> = ({
  groupName,
  members,
  terminals,
  onClickInviteToSelectedGroups,
}) => {
  const [open, setOpen] = React.useState(false)

  return (
    <Card noPadding>
      <CardBar open={true}>
        <Row justify="between" align="center">
          <Subtitle color={theme.colors.white}>{groupName}</Subtitle>
          <SelectSection>
            <PrimaryButton title="Add to group" icon={<CheckmarkIcon />} onClick={onClickInviteToSelectedGroups} />
          </SelectSection>
        </Row>
      </CardBar>
      <Content>
        <Row justify="center">
          <HoverLinkText
            onClick={() => setOpen(!open)}
            title={open ? "Hide members and terminals" : "Show members and terminals"}
            icon={
              open ? (
                <ArrowDropUpIcon color={theme.colors.greyDark} />
              ) : (
                <ArrowDropDownIcon color={theme.colors.greyDark} />
              )
            }
          />
        </Row>
        <SlideOutHeight isVisible={open}>
          <HorizontalSpacer spacing={1} />
          <Row gutterWidth={16} style={{ padding: "16px 8px" }}>
            {members.map((member) => (
              <Col md={3} xs={12} style={{ margin: 8 }} key={member.member.id}>
                <MemberProfileOverview
                  imgSrc={member.member?.src ?? FALLBACK_PICTURE}
                  name={member.member.name}
                  role={member.member.role}
                  title={member.member.title}
                />
              </Col>
            ))}
          </Row>
          <HorizontalSpacer spacing={2} />
          <Row gutterWidth={16} justify="between" style={{ padding: "16px 8px" }}>
            {terminals.map((terminal) => (
              <Col md={3} xs={12} style={{ margin: 8 }} key={terminal.id}>
                <MemberProfileOverview imgSrc={terminal.src} name={terminal.name} role={terminal.serialNumber} />
              </Col>
            ))}
          </Row>
        </SlideOutHeight>
      </Content>
    </Card>
  )
}

export default GroupSelectionSection
